import { StyleSheet } from 'react-native';
import { Bot } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type AssistantWelcomeCardProps = {
  greeting: string;
};

export function AssistantWelcomeCard({ greeting }: AssistantWelcomeCardProps) {
  return (
    <AppCard style={styles.card}>
      <Bot size={22} color={tokens.colors.primary} />
      <AppText variant="body">{greeting}</AppText>
    </AppCard>
  );
}

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: tokens.spacing.md,
  },
});
